import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=ba50d6c8&scoped=true"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"
import style0 from "./addAdmin.vue?vue&type=style&index=0&id=ba50d6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba50d6c8",
  null
  
)

export default component.exports